/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { VisitPackageInfoStageDto } from './visit-package-info-stage-dto';

/**
 * 
 * @export
 * @interface VisitPackageInfoDto
 */
export interface VisitPackageInfoDto {
    /**
     * 
     * @type {number}
     * @memberof VisitPackageInfoDto
     */
    'lowestPrice': number;
    /**
     * 
     * @type {string}
     * @memberof VisitPackageInfoDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VisitPackageInfoDto
     */
    'packageType': string;
    /**
     * 
     * @type {Array<VisitPackageInfoStageDto>}
     * @memberof VisitPackageInfoDto
     */
    'stages': Array<VisitPackageInfoStageDto>;
    /**
     * 
     * @type {string}
     * @memberof VisitPackageInfoDto
     */
    'type': VisitPackageInfoDtoTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum VisitPackageInfoDtoTypeEnum {
    Epilepsy = 'EPILEPSY',
    Consultation = 'CONSULTATION'
}


